import { axiosInstance } from './api';
import type { Paginated } from './types';

export interface TableDto {
  id: string;
  area: string;
  name: string;
  perspective_width: number | null;
  perspective_height: number | null;
  /** False for fixed surfaces (bar counters) — the pipeline then never reports
   *  «стол не на месте» for them, because they cannot be out of place. */
  can_be_physically_moved: boolean;
  /** Порог уверенности «стол грязный» для алерта (0–1); null — системный (AI214). */
  alert_min_dirty_conf?: number | null;
  /** Проверять «состояние нельзя определить» (несколько столов / перекрыт) LLM-ом. */
  spoiled_check?: boolean;
  /** Только засвет: полигон по разметке всегда накрывает несколько столешниц (диван с
   *  двумя-тремя столами), вопросы «несколько столов / перекрыт» не задаются. */
  spoiled_glare_only?: boolean;
  /** Статус «состояние стола нельзя определить» стоит с этого момента (read-only). */
  spoiled_since?: string | null;
  /** Причина статуса: several_tables | obstructed | glare (read-only). */
  spoiled_reason?: TableSpoiledReason | null;
  /** Осветление кропа, 0..1: 0 — выкл, 1 — CLAHE + гамма 0.5 (Алексей 26.10, #7770). */
  crop_brighten?: number;
  /** Архив стола: скрыт из анализа, разметка/история сохранены, обратимо (Эдем 04.11). */
  is_archived?: boolean;
}

export type TableSpoiledReason = 'several_tables' | 'obstructed' | 'glare';

export interface TableCreateDto {
  area: string;
  name: string;
  perspective_width?: number | null;
  perspective_height?: number | null;
  can_be_physically_moved?: boolean;
  alert_min_dirty_conf?: number | null;
  spoiled_glare_only?: boolean;
  crop_brighten?: number;
  is_archived?: boolean;
}

export type TablePatchDto = Partial<TableCreateDto>;

export const listTablesByAreas = (areaIds: string[], pageSize = 1000) => {
  if (!areaIds || areaIds.length === 0) {
    return Promise.resolve({ data: { results: [] as TableDto[] } } as { data: Paginated<TableDto> });
  }
  const ids = areaIds.join(',');
  // Match backend filter usage pattern with racks: filter by area_id__in
  return axiosInstance.get<Paginated<TableDto>>(`/table_control/table/?area_id__in=${ids}&page_size=${pageSize}`);
};

export const listTablesByCamera = (cameraId: string, pageSize = 1000) => {
  return axiosInstance.get<Paginated<TableDto>>(`/table_control/table/?area__camera=${cameraId}&page_size=${pageSize}`);
};

export const createTable = (payload: TableCreateDto) => {
  return axiosInstance.post<TableDto>('/table_control/table/', payload);
};

export const patchTable = (tableId: string, payload: TablePatchDto) => {
  return axiosInstance.patch<TableDto>(`/table_control/table/${tableId}/`, payload);
};

/** keepArea — смена типа: снять только сущность, полигон оставить (#3222). */
export const deleteTable = (tableId: string, keepArea = false) => {
  return axiosInstance.delete(`/table_control/table/${tableId}/`, keepArea ? { params: { keep_area: 1 } } : undefined);
};
